import { toSafeWhitespaceString } from '../utils/toSafeWhitespaceString.js';

export const DEFAULT_THREAD_TITLE = 'New thread';
const PROVISIONAL_TITLE_MAX_CHARS = 50;

/**
 * The title a conversation carries from its first message until the server writes a generated one.
 * The web names a new conversation with it and the server compares against it to know the title is
 * still provisional, so both must build it the same way.
 */
const buildProvisionalThreadTitle = (message) => {
  return toSafeWhitespaceString(message).slice(0, PROVISIONAL_TITLE_MAX_CHARS).trim() || DEFAULT_THREAD_TITLE;
};

export default buildProvisionalThreadTitle;
